import { apiGet, apiSend, USE_MOCK_API } from './httpClient'
import { STORE_KEYS, readCollection, writeCollection, latency } from './store'
import { updatePoint } from './points.mock'
export interface TripNote { id: string; trip_id: string; point_id: string | null; text: string; created_at: string }
export async function listNotes(tripId: string): Promise<TripNote[]> {
  if (!USE_MOCK_API) return apiGet(`/trips/${tripId}/notes`)
  return latency(readCollection<TripNote>(STORE_KEYS.notes).filter(n=>n.trip_id===tripId))
}
export async function addNote(tripId: string, input: {client_id:string;point_id:string|null;text:string}): Promise<TripNote> {
  if (!USE_MOCK_API) return apiSend('POST',`/trips/${tripId}/notes`,input)
  const notes=readCollection<TripNote>(STORE_KEYS.notes)
  const existing=notes.find(n=>n.id===input.client_id)
  if (existing) return latency(existing)
  const note={id:input.client_id,trip_id:tripId,point_id:input.point_id,text:input.text,created_at:new Date().toISOString()}
  notes.push(note);writeCollection(STORE_KEYS.notes,notes)
  if (input.point_id) {
    const {listPoints}=await import('./points.mock')
    const point=(await listPoints(tripId)).find(p=>p.id===input.point_id)
    if (point) await updatePoint(tripId,point.id,{notes:point.notes ? `${point.notes}\n${input.text}`:input.text})
  }
  return latency(note)
}
